export const Sparkle = ({ className = "h-5 w-5" }) => (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
        <defs>
            <linearGradient id="cbz-sparkle" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stopColor="#FCB21E" />
                <stop offset="0.5" stopColor="#F35E6A" />
                <stop offset="1" stopColor="#5E11BD" />
            </linearGradient>
        </defs>
        <path
            fill="url(#cbz-sparkle)"
            d="M12 0c.9 6.6 5.4 11.1 12 12-6.6.9-11.1 5.4-12 12-.9-6.6-5.4-11.1-12-12C6.6 11.1 11.1 6.6 12 0Z"
        />
    </svg>
);

// Blue on light backgrounds, white on blue/navy backgrounds, black for monochrome use.
const LOGO_SRC = {
    blue: "/logos/contabeleza-azul.svg",
    white: "/logos/contabeleza-branca.svg",
    black: "/logos/contabeleza-preta.svg",
};

const Logo = ({ variant = "blue", className = "h-7 w-auto" }) => (
    <img
        src={LOGO_SRC[variant] ?? LOGO_SRC.blue}
        alt="Contabeleza"
        width="1140"
        height="166"
        className={className}
        data-testid="brand-logo"
    />
);

export default Logo;
